import { useProfile } from '@/routes/Providers/ProfileProvider';
import { useSsoConfig } from '@/shared/utils/sso';

// SSO discovery is required because the backend proxy exchanges the
// SSO-linked session for the agent's own token, so every AI entry hides
// wherever SSO surfaces hide.
export function useAiAvailable(): boolean {
  const { profile } = useProfile();
  const ssoConfig = useSsoConfig();
  return profile !== null && ssoConfig?.enabled === true;
}
